import * as THREE from 'three';

export const makeUnclickableThreeObject = (obj: THREE.Object3D) => {
  obj.raycast = () => {
    //
  };
};
